import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { PublicClientApplication, BrowserAuthError } from "@azure/msal-browser";
import { useState, useEffect } from "react";
import msalConfig from "./configs/msal-config";

import App from "./App";
import { Login } from "./screens/login";

const msalInstance = new PublicClientApplication(msalConfig);

function AppShell() {
  const [isMsalInitialized, setIsMsalInitialized] = useState(false);

  // 1. Check if the current path should bypass auth
  const isPublicRoute = window.location.pathname === "/licenses";

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await msalInstance.initialize();
        await msalInstance.handleRedirectPromise();
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          msalInstance.setActiveAccount(accounts[0]);
        }
        setIsMsalInitialized(true);
      } catch (error) {
        if (error instanceof BrowserAuthError && error.errorCode === "no_token_request_cache_error") {
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
          }
          setIsMsalInitialized(true);
        } else {
          console.error("Failed to initialize MSAL:", error);
        }
      }
    };
    initializeMsal();
  }, []);

  if (!isMsalInitialized) {
    return <div>Loading...</div>;
  }

  // 2. If it's a public route, render App directly without MSAL templates
  if (isPublicRoute) {
    return (
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <App />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}

export default AppShell;